import React from "react";

interface RestaurantLogoProps {
  src?: string | null;
  name?: string | null;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "square" | "circle";
  className?: string;
}

const sizeClasses: Record<NonNullable<RestaurantLogoProps["size"]>, string> = {
  sm: "w-12 h-12",
  md: "w-16 h-16 md:w-20 md:h-20",
  lg: "w-24 h-24",
  xl: "w-28 h-28",
};

export const RestaurantLogo: React.FC<RestaurantLogoProps> = ({
  src,
  name,
  size = "md",
  variant = "square",
  className = "",
}) => {
  if (!src) return null;
  const alt = `Logo de ${name || "restaurante"}`;
  
  const containerClass = variant === "circle" ? "rounded-full" : "rounded-lg";
  const imageClass = variant === "circle" ? "rounded-full" : "rounded-lg";

  return (
    <div
      className={`${sizeClasses[size]} ${containerClass} overflow-hidden p-2 ${className}`}
      aria-label={alt}
    >
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-contain ${imageClass}`}
        loading="eager"
      />
    </div>
  );
};

export default RestaurantLogo;
